/* eslint-disable @typescript-eslint/no-empty-function */
import CamposPersonalizadoBoardAddButton from "../AddNewItemButton"
import CamposPersonalizadoBoardListItem from "../BoardListItem"

import "./styles.scss"

const CamposPersonalizadoBoardList = ({
  camposPersonalizados,
  endpointSlice = "",
  removeItem = () => {},
  addEmptyLine = () => {},
}: $TSMigrationFixMe) => {
  return (
    <div className='campos-personalizados-board-list px-2 py-3'>
      {camposPersonalizados?.length ? (
        <>
          {camposPersonalizados?.map(
            (campo: $TSMigrationFixMe, index: $TSMigrationFixMe) => (
              <CamposPersonalizadoBoardListItem
                key={campo.id}
                index={index}
                removeItem={removeItem}
                endpointSlice={endpointSlice}
              />
            )
          )}
        </>
      ) : (
        <CamposPersonalizadoBoardAddButton addEmptyLine={addEmptyLine} />
      )}
    </div>
  )
}

export default CamposPersonalizadoBoardList
